import React from 'react'
import {
    FormKatalogProgramTwo,
    FormKatalogProgramThree,
    FormKatalogProgramFour,
    FormKatalogProgramFive,
    RegistrationPageSixComp,
    FinishPaymentIndividu,
    ThankYouComp,
    FormKatalogParticipant
} from '../../'


const CardBodyKatalogProgram = (props) => {

    switch (props.page) {
        case 2:
            return (
                <>
                    <FormKatalogProgramTwo />
                </>
            );
        case 3:
            return (
                <>
                    <FormKatalogProgramThree />
                </>
            );
        case 4:
            return (
                <>
                    <FormKatalogProgramFour />
                </>
            );
        case 4.5:
            return (
                <>
                    <FormKatalogParticipant />
                </>
            );
        case 5:
            return (
                <>
                    <FormKatalogProgramFive />
                </>
            );
        case 6:
            return (
                <>
                    <RegistrationPageSixComp />
                </>
            );
        case 7:
            return (
                <>
                    <FinishPaymentIndividu />
                </>
            );
        case 8:
            return (
                <>
                    <ThankYouComp />
                </>
            );
        default:
            return (
                <>
                    <FormKatalogProgramTwo />
                </>
            );
    }
}

export default CardBodyKatalogProgram
